export default {

  todaysSelfCheckIn(state, data) {
    state.todaysSelfCheckIn = data;
  },
  
};
